import React, { createContext } from 'react';
import { useWindowSize, WindowSizeType } from '../hooks/useWindowSize';

const VERTICAL_RATE = 0.88;
const HORIZONTAL_RATE = 1;

type WindowSizeContextType = {
  size: WindowSizeType;
};

export const WindowSizeContext = createContext({} as WindowSizeContextType);

type Props = {
  children: React.ReactNode;
};

// 画面サイズの情報を取得するContext
export const WindowSizeContextProvider: React.FC<Props> = ({ children }) => {
  const { size } = useWindowSize(HORIZONTAL_RATE, VERTICAL_RATE);

  return (
    <WindowSizeContext.Provider value={{ size }}>
      {children}
    </WindowSizeContext.Provider>
  );
};
